import BaseService from "./BaseService";

class RoleService {
  static async list(data) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/roles?${queryParams}`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/roles`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/roles/${id}`);
  }

  static async update({ id, data }) {
    return await BaseService.callAPI(`/roles/${id}`, "POST", data);
  }

  static async dropDown() {
    return await BaseService.callAPI(`/roles/dropdown`);
  }

  static async users({ id, data }) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/roles/${id}/users?${queryParams}`);
  }

  static async export({ fileType, data, id }) {
    const params = BaseService.cleanQueryParams(data);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `/roles/${id}/users/export/${fileType}?${queryParams}`,
      "POST",
      null,
      { responseType: "blob" }
    );
  }
}

export default RoleService;
